import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { colorConfig } from 'src/app/shared/services/theme-constant.service';
import { MainService } from '@main/main.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  usersDetails = [];
  isSmallSizeVideoScreen = false;
  oneToOneCallStarted = false;
  VipTableCallStarted = false;
  isMatchingMember = false;
  triggerConnect = new BehaviorSubject(false);
  loading = new BehaviorSubject(false);
  profileUpdated = new BehaviorSubject(false);
  breadCrumbSubtitle = new BehaviorSubject({});
  breadCrumbSubtitle2 = new BehaviorSubject({});
  stakeholderData = new BehaviorSubject(null);
  moderatorData = new BehaviorSubject(null);
  announcementData = new BehaviorSubject(null);

  isConferenceCallStarted = new BehaviorSubject(false);
  endLoungeCallS = new BehaviorSubject(false);
  isLogout = new BehaviorSubject(false);
  app_version = 'Version 2.0.19';
  url_pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/;

  $stakeholderData = this.stakeholderData.asObservable();
  $moderatorData = this.moderatorData.asObservable();
  $announcementData = this.announcementData.asObservable();

  organizerData = new BehaviorSubject(null);
  $organizerData = this.organizerData.asObservable();

  collaboratorData = new BehaviorSubject(null);
  $collaboratorData = this.collaboratorData.asObservable();
  eventList = new BehaviorSubject([]);
  firebaseLoginStatus = new BehaviorSubject(false);

  previewPluginData = new BehaviorSubject(null);
  revenueMail = {
    subject: 'Try This Event Networking Must-Have For 2 Weeks, Free! 👉',
    body: `Hi,<br><br>We know you enjoy attending our events and meeting new people. That’s why we want to let you know about Hio Premium, a must-have for networking professionals.<br><br>With Hio Premium, you'll be able to:<ul><li>Create a video elevator pitch, so you can expand your network</li><li>Boost your profile among other event guests for increased visibility</li><li>Send your contacts to your CRM, saving hours of manual business card entry</li><li>Make introductions, so you can build trust among your network</li><li>Save your contacts to your device, so you can access them anytime</li></ul><br><br>Ready to save time and effort all while deepening your relationships?<br><br><a href="">UPGRADE TO PREMIUM NOW</a><br><br>About Hio:<br>Hio is a Philadelphia-based networking & event platform founded on the belief that hitting it off with others before, during & after events should be fun & easy. We want to help you discover the common threads that bond you to others—so you can foster deeper, more dynamic relationships.<br><br>Here’s to hitting it off!<br><Event Organizer’s Name><br>`
  };
  mailItems = [
    {
      subject: 'Invitation to <Event Organizer’s Company>’s Networking App',
      body: `YOUR EVENT DETAILS<br><br>Event Name: <Event Name><br>Date & Time: <Date and Time><br>Location: <Location><br>Event URL: <Event URL><br>Unique URL: <Event Unique URL><br>Event Specific Passcode: <Passcode><br><br>Hi,<br><br>Thanks for registering for <Event Name>! In order to have the best event experience, we've <br>teamed up with Hio, an exciting new networking app that makes it easy to find, friend & <br>follow up.<br>With Hio, you’ll be able to view event details, get directions, network with attendees, join <br>the live chat, redeem sponsor offers, and view the event’s social media activity.<br>Since all of our events will be hosted on Hio, we recommend you download and setup Hio prior <br>to the event:<br><a href="<Event Unique URL>">DOWNLOAD NOW</a><br><br>EASY SETUP STEPS<br>1. Download Hio<br>2. Setup your profile<br>3. Join the event and start networking<br>4. Keep Hio handy for the next <Event Organizer> event!<br><br>About Hio:<br>Hio is a Philadelphia-based networking & event organizing platform founded on the belief that <br>hitting it off with others before, during & after events should be fun & easy. We want to <br>help you discover the common threads that bond you to others—so you can foster deeper, more <br>dynamic relationships.<br>Thanks, and we can't wait to see you there!<br><Event Organizer’s Name><br><br>SOCIAL MEDIA SECTION<br>Let's be friends!<br>We love to keep up with all the networking and events you're doing out there.<br>Tap or click below to follow us on whatever platform you'd like.<br><p><a href="https://www.facebook.com/Hiosocial/" target="_blank">Facebook</a>  <a href="https://twitter.com/hiosocial" target="_blank">Twitter</a>  <a href="https://www.instagram.com/hiosocial/" target="_blank">Instagram</a>  <a href="https://www.linkedin.com/company/hiosocial/" target="_blank">LinkedIn </a></p><br>You’re receiving this email because <Event Organizer’s Company> invited you to create a Hio <br>account.<br>We’ll be using it to send you info that will help you make the most of your Hio account.<br><br>© 2019 Hio, a Contap Inc. Company, 1720 Folsom Street, Philadelphia, PA 19130<br>Unsubscribe | <a href="https://hiosocial.com/privacy" target="_blank">Privacy Policy</a>`
    },
    {
      subject: 'Want to Start Networking Before the Event? 👋 ',
      body: `YOUR EVENT DETAILS<br><br>Event Name: <Event Name><br>Date & Time: <Date and Time><br>Location: <Location><br>Event URL: <Event URL><br>Unique URL: <Event Unique URL><br>Event Specific Passcode: <Passcode><br><br>Hi,<br><br>Thanks for registering for <Event Name>! We’re excited to introduce you to Hio, an exciting new networking app we’ll be using at all of our events.<br><br>This app will help make your experience at our event more enjoyable and make it easier to find, friend & follow up.<br><br>We recommend you download and setup Hio today, so you can start networking right away!<br><br><a href="<Event Unique URL>">DOWNLOAD NOW</a><br><br>EASY SETUP STEPS<br>1. Download Hio<br>2. Setup your profile<br>3. Join the event and start networking<br>4. Keep Hio handy for the next <Event Organizer> event!<br><br>About Hio:<br>Hio is a Philadelphia-based networking & event organizing platform founded on the belief that hitting it off with others before, during & after events should be fun & easy. We want to help you discover the common threads that bond you to others—so you can foster deeper, more dynamic relationships.<br><br>Thanks, and we can't wait to see you there!<br><Event Organizer’s Name><br><br>SOCIAL MEDIA SECTION<br><br>Let's be friends!<br><br>We love to keep up with all the networking and events you're doing out there.<br>Tap or click below to follow us on whatever platform you'd like.<br><br><p><a href="https://www.facebook.com/Hiosocial/" target="_blank">Facebook</a>  <a href="https://twitter.com/hiosocial" target="_blank">Twitter</a>  <a href="https://www.instagram.com/hiosocial/" target="_blank">Instagram</a>  <a href="https://www.linkedin.com/company/hiosocial/" target="_blank">LinkedIn </a></p><br><br>You’re receiving this email because <Event Organizer’s Company> invited you to create a Hio account.<br>We’ll be using it to send you info that will help you make the most of your Hio account.<br><br>© 2019 Hio, a Contap Inc. Company, 1720 Folsom Street, Philadelphia, PA 19130<br>Unsubscribe | <a href="https://hiosocial.com/privacy" target="_blank">Privacy Policy</a>`
    },
    {
      subject: '⏰ It’s Time to Start Your Event Networking',
      body: `YOUR EVENT DETAILS<br><br>Event Name: <Event Name><br>Date & Time: <Date and Time><br>Location: <Location><br>Event URL: <Event URL><br>Unique URL: <Event Unique URL><br>Event Specific Passcode: <Passcode><br><br>Hi,<br><br>We’re looking forward to seeing you soon at <Event Name>. We’re also writing to invite you to download Hio, an exciting new networking app we’ll be using at all of our events.<br><br>Hio will make it easy to find, friend and follow up with your fellow attendees before, during and after the event. Plus, you’ll be able to use it at our future events and in your everyday life.<br><br>Don’t wait—begin networking & join the live chat with your fellow attendees today!<br><br><a href="<Event Unique URL>">DOWNLOAD NOW</a><br><br>EASY SETUP STEPS<br>1. Download Hio<br>2. Setup your profile<br>3. Join the event and start networking<br>4. Keep Hio handy for the next <Event Organizer> event!<br><br>About Hio:<br>Hio is a Philadelphia-based networking & event organizing platform founded on the belief that hitting it off with others before, during & after events should be fun & easy. We want to help you discover the common threads that bond you to others—so you can foster deeper, more dynamic relationships.<br><br>Thanks, and we can't wait to see you there!<br><Event Organizer’s Name><br><br>SOCIAL MEDIA SECTION<br><br>Let's be friends!<br><br>We love to keep up with all the networking and events you're doing out there.<br>Tap or click below to follow us on whatever platform you'd like.<br><br><p><a href="https://www.facebook.com/Hiosocial/" target="_blank">Facebook</a>  <a href="https://twitter.com/hiosocial" target="_blank">Twitter</a>  <a href="https://www.instagram.com/hiosocial/" target="_blank">Instagram</a>  <a href="https://www.linkedin.com/company/hiosocial/" target="_blank">LinkedIn </a></p><br><br>You’re receiving this email because <Event Organizer’s Company> invited you to create a Hio account.<br>We’ll be using it to send you info that will help you make the most of your Hio account.<br><br>© 2019 Hio, a Contap Inc. Company, 1720 Folsom Street, Philadelphia, PA 19130<br>Unsubscribe | <a href="https://hiosocial.com/privacy" target="_blank">Privacy Policy</a>`
    },
    {
      subject: 'Time’s Running Out! 😨',
      body: `YOUR EVENT DETAILS<br><br>Event Name: <Event Name><br>Date & Time: <Date and Time><br>Location: <Location><br>Event URL: <Event URL><br>Unique URL: <Event Unique URL><br>Event Specific Passcode: <Passcode><br><br>Hi,<br><br><Event Name> is right around the corner, and your fellow attendees are already using Hio to network with each other. Hio is an exciting new networking app that makes it super easy to find, friend and follow up with anyone you meet.<br><br>We want you to get started with Hio right away so that you don’t miss out on any of the action.<br><br>So don’t wait—download Hio today!<br><br><a href="<Event Unique URL>">DOWNLOAD NOW</a><br><br>EASY SETUP STEPS<br>1. Download Hio<br>2. Setup your profile<br>3. Join the event and start networking<br>4. Keep Hio handy for the next <Event Organizer> event!<br><br>About Hio:<br>Hio is a Philadelphia-based networking & event organizing platform founded on the belief that hitting it off with others before, during & after events should be fun & easy. We want to help you discover the common threads that bond you to others—so you can foster deeper, more dynamic relationships.<br><br>Thanks, and we can't wait to see you there!<br><Event Organizer’s Name><br><br>SOCIAL MEDIA SECTION<br><br>Let's be friends!<br><br>We love to keep up with all the networking and events you're doing out there.<br>Tap or click below to follow us on whatever platform you'd like.<br><br><p><a href="https://www.facebook.com/Hiosocial/" target="_blank">Facebook</a>  <a href="https://twitter.com/hiosocial" target="_blank">Twitter</a>  <a href="https://www.instagram.com/hiosocial/" target="_blank">Instagram</a>  <a href="https://www.linkedin.com/company/hiosocial/" target="_blank">LinkedIn </a></p><br><br>You’re receiving this email because <Event Organizer’s Company> invited you to create a Hio account.<br>We’ll be using it to send you info that will help you make the most of your Hio account.<br><br>© 2019 Hio, a Contap Inc. Company, 1720 Folsom Street, Philadelphia, PA 19130<br>Unsubscribe | <a href="https://hiosocial.com/privacy" target="_blank">Privacy Policy</a>`
    },
    {
      subject: 'Only 2 Days Left: Download Our Event App Now! 🚨',
      body: `YOUR EVENT DETAILS<br><br>Event Name: <Event Name><br>Date & Time: <Date and Time><br>Location: <Location><br>Event URL: <Event URL><br>Unique URL: <Event Unique URL><br>Event Specific Passcode: <Passcode><br><br>Hi,<br><br>The event is almost here, and your fellow attendees are having a blast networking and chatting.<br><br>They are just loving Hio—and loving how easy it is to find, friend & follow up at events and in their everyday life, too.<br><br>Don’t miss out on being a part of the action.<br><br>So go ahead—download Hio now!<br><br><a href="<Event Unique URL>">DOWNLOAD NOW</a><br><br>EASY SETUP STEPS<br>1. Download Hio<br>2. Setup your profile<br>3. Join the event and start networking<br>4. Keep Hio handy for the next <Event Organizer> event!<br><br>About Hio:<br>Hio is a Philadelphia-based networking & event organizing platform founded on the belief that hitting it off with others before, during & after events should be fun & easy. We want to help you discover the common threads that bond you to others—so you can foster deeper, more dynamic relationships.<br><br>Thanks, and we can't wait to see you there!<br><Event Organizer’s Name><br><br>SOCIAL MEDIA SECTION<br><br>Let's be friends!<br><br>We love to keep up with all the networking and events you're doing out there.<br>Tap or click below to follow us on whatever platform you'd like.<br><br><p><a href="https://www.facebook.com/Hiosocial/" target="_blank">Facebook</a>  <a href="https://twitter.com/hiosocial" target="_blank">Twitter</a>  <a href="https://www.instagram.com/hiosocial/" target="_blank">Instagram</a>  <a href="https://www.linkedin.com/company/hiosocial/" target="_blank">LinkedIn </a></p><br><br>You’re receiving this email because <Event Organizer’s Company> invited you to create a Hio account.<br>We’ll be using it to send you info that will help you make the most of your Hio account.<br><br>© 2019 Hio, a Contap Inc. Company, 1720 Folsom Street, Philadelphia, PA 19130<br>Unsubscribe | <a href="https://hiosocial.com/privacy" target="_blank">Privacy Policy</a>`
    }
  ];

  monthNames: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  themeColors = colorConfig.colors;
  colorsArray = [this.themeColors.blue, this.themeColors.cyan, this.themeColors.purple, this.themeColors.gold, this.themeColors.red];
  constructor(
    private router: Router,
    private mainService: MainService,
    private msgService: NzMessageService
  ) { }

  clearLocalStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  clearLocalAndRedirectToIndex(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['']);
  }

  getDaysInMonth(month: number = 0, year: number) {
    const date = new Date(Date.UTC(year, month, 1));
    const days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  formatDate(val: any, shortMonth: boolean = false) {
    val = new Date(val);
    const day = val.getDay();
    const date = val.getDate();
    const monthIndex = val.getMonth();
    const year = val.getFullYear();
    const month = shortMonth ? this.monthNames[monthIndex].substring(0, 3) : this.monthNames[monthIndex];
    return this.dayNames[day] + ', ' + month + ' ' + date + ', ' + year;
  }

  IsJsonString(value: string) {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  }

  getKeyFromUserInfo(key?: string): any {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo && this.IsJsonString(userInfo)) {
      const creds = JSON.parse(userInfo);
      if (key && Object.keys(creds).length && creds.hasOwnProperty(key)) {
        return creds[key];
      } else {
        return creds;
      }
    }
    return null;
  }

  setStakeholderData(data) {
    this.stakeholderData.next(data);
  }

  setModeratorData(data) {
    this.moderatorData.next(data);
  }

  setorganizerData(data) {
    this.organizerData.next(data);
  }

  setcollaboratorData(data) {
    this.collaboratorData.next(data);
  }

  setAnnouncementData(data) {
    this.announcementData.next(data);
  }

  returnBase64String(file) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.toString());
      };
      reader.readAsDataURL(file);
    });
  }

  // return image base64 string from image URL
  async toBase64(url: string) {
    return await new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  getUsersDetails(userId) {
    const filterUser = this.usersDetails.find(x => x.id === userId);
    return filterUser || false;
  }

  // Sort and calulate analytics survey data
  sortAndCalculateSurvey(arr: Array<any>): Array<any> {
    arr.forEach((obj: any, i: number) => {
      obj.percent = Math.ceil(parseInt(((+obj.yes_count / (+obj.no_count + +obj.yes_count)) * 100).toString(), 10));
      obj.question = obj.question.charAt(0).toUpperCase() + obj.question.slice(1);
      obj.color = this.getColor(i);
      return obj;
    });
    return arr.sort((a, b) => {
      return parseInt(b.percent, 10) - parseInt(a.percent, 10);
    });
  }

  // Sort and calulate analytics data
  sortAndCalculate(arr: Array<any>): Array<any> {
    const total_count = arr.reduce((cnt, o) => cnt + o.count, 0);
    arr.forEach((obj: any, i: number) => {
      obj.percent = Math.ceil(parseInt(((+obj.count / +total_count) * 100).toString(), 10));
      obj.color = this.getColor(i);
      return obj;
    });
    return arr.sort((a, b) => {
      return parseInt(b.percent, 10) - parseInt(a.percent, 10);
    });
  }

  getColor(index: number): string {
    const num = index % (this.colorsArray.length);
    return this.colorsArray[num];
  }

  // Format Demographic Details
  getFormattedDemographicDetails(analyticsData: any) {
    const companies = analyticsData && analyticsData.company_details && analyticsData.company_details.length
      ? analyticsData.company_details : [];
    const interests = analyticsData && analyticsData.interest_details &&
      analyticsData.interest_details.length ? analyticsData.interest_details : [];
    const job_titles = analyticsData && analyticsData.job_title_details &&
      analyticsData.job_title_details.length ? analyticsData.job_title_details : [];
    const locations = analyticsData && analyticsData.location_details &&
      analyticsData.location_details.length ? analyticsData.location_details : [];

    return {
      allCompanies: companies.length ? this.sortAndCalculate(companies) : [],
      companiesData: companies.length ? this.sortAndCalculate(companies).slice(0, 5) : [],
      allInterests: interests.length ? this.sortAndCalculate(interests) : [],
      interestsData: interests.length ? this.sortAndCalculate(interests).slice(0, 5) : [],
      allJobs: job_titles.length ? this.sortAndCalculate(job_titles) : [],
      jobsData: job_titles.length ? this.sortAndCalculate(job_titles).slice(0, 5) : [],
      allLocations: locations.length ? this.sortAndCalculate(locations) : [],
      locationsData: locations.length ? this.sortAndCalculate(locations).slice(0, 5) : [],
    };
  }

  async getCardDetail() {
    try {
      const resp: any = await this.mainService.getCard().toPromise();
      if (resp && resp.success) {
        if (resp.data.length) {
          return resp.data;
        }
      }
      return [];
    } catch (error) {
      console.log('Error: ', error);
    }
  }

  // From https://stackoverflow.com/a/33928558/1995444
  copyToClipBoard(key: string, val: string) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    if ((<any>window).clipboardData && (<any>window).clipboardData.setData) {
      // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
      return (<any>window).clipboardData.setData('Text', val);
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      const textarea = document.createElement('textarea');
      textarea.textContent = val;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        this.msgService.success(`${key} successfully copied to clipboard!`);
        return document.execCommand('copy'); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn('Copy to clipboard failed.', ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
}
